/**
 * Theme handler for managing dark mode and OS preference detection
 */

export class ThemeHandler {
  private static instance: ThemeHandler;
  private mediaQuery: MediaQueryList | null = null;

  public static getInstance(): ThemeHandler {
    if (!ThemeHandler.instance) {
      ThemeHandler.instance = new ThemeHandler();
    }
    return ThemeHandler.instance;
  }

  private constructor() {
    this.initializeOSListener();
  }

  private initializeOSListener() {
    if (typeof window === "undefined") return;

    this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    // Listen for OS preference changes
    this.mediaQuery.addEventListener("change", this.handleOSPreferenceChange);
  }

  private handleOSPreferenceChange = (e: MediaQueryListEvent) => {
    // The atom system will handle this automatically
    // This handler is kept for potential future use
    console.log("OS preference changed", e.timeStamp);
  };

  public applyTheme(isDark: boolean) {
    if (typeof document === "undefined") return;

    const root = document.documentElement;
    const body = document.body;

    if (isDark) {
      root.classList.add("dark");
      body.classList.add("dark");
      root.style.colorScheme = "dark";
      // Force update CSS variables
      // root.style.setProperty("--background", "#0f172a");
      // root.style.setProperty("--foreground", "#f8fafc");
      // root.style.setProperty("--muted", "#1e293b");
      // root.style.setProperty("--muted-foreground", "#94a3b8");
      // root.style.setProperty("--border", "#334155");
      // root.style.setProperty("--card", "#1e293b");
      // root.style.setProperty("--card-foreground", "#f8fafc");
    } else {
      root.classList.remove("dark");
      body.classList.remove("dark");
      root.style.colorScheme = "light";
      // Force update CSS variables
      // root.style.setProperty("--background", "#ffffff");
      // root.style.setProperty("--foreground", "#0f172a");
      // root.style.setProperty("--muted", "#f1f5f9");
      // root.style.setProperty("--muted-foreground", "#64748b");
      // root.style.setProperty("--border", "#e2e8f0");
      // root.style.setProperty("--card", "#ffffff");
      // root.style.setProperty("--card-foreground", "#0f172a");
    }
  }

  public cleanup() {
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener(
        "change",
        this.handleOSPreferenceChange,
      );
    }
  }
}

// Export singleton instance
export const themeHandler = ThemeHandler.getInstance();
